import { createCustomEvent } from './Event'
import { ErrorCollector } from './ErrorCollector'
import { UEC_NAME } from './consts'

declare global {
	interface Window {
		NutstoreErrorCollector?: string
	}
}

try {
	bootstrap()
} catch (err) {
	console.error(err)
}

function bootstrap() {
	const collectorName = window.NutstoreErrorCollector || UEC_NAME
	const collector = new ErrorCollector((window as any)[collectorName], {
		onInited() {
			window.dispatchEvent(createCustomEvent(`${UEC_NAME}:inited`))
		},
	})
	;(window as any)[collectorName] = collector.call
	window.dispatchEvent(createCustomEvent(`${UEC_NAME}:loaded`))

	const initMetaTag: HTMLMetaElement | null = document.querySelector(
		'meta[name="uec:init"]',
	)
	if (initMetaTag && initMetaTag.content) {
		collector.call('init', JSON.parse(initMetaTag.content))
	}
}
